import * as utility from "./services.js"
import * as react_components from "./reactcomponent.js"
import { ParamsToStore, StatisticDataStore } from "./stores/statisticsDataStore.js"
import { getGlobalSettings } from "./settings.js"
import { Innosoft_InnoBI_Controllers_StatisticUiController as StatisticUiController, Innosoft_WebCRM_Statistics_Controllers_SettingsController as SettingsController } from "./generated_api/generated_api.js"
import * as common_components from "./editor_common_components.js"
import * as propertyTypes from "./property_types.js"
import { Helper, BrowserStorageType } from "../core/util/helper.js"
import { WebSmsUiEditor } from "./websms_ui_editor.js"
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { registerComponents } from "./components_registrar.js"
import { Button } from "../core/components/button.js"
import { SearchHelper } from "../core/util/searchfieldHelper.js"
import React from "react";
import ReactDOM from "react-dom";

export { registerComponents };

interface IStatisticViewerProps extends React.PropsWithChildren {
    statisticId: number;
    realStatisticId: number;
    uiDefinition: any;
    parameters: any;
    controllerCode: any;
    contextVariables: any;
    drillDownParams: any;
    hideParameters: boolean;
    menuHidden?: boolean;
    dataStore?: StatisticDataStore,
    isDrillDown?: boolean;
    refreshIfParametersChanged?: boolean;
    isEmbedded?: boolean;
    drillDowny: any
}

interface StatisticViewerState {
    isLoading?: boolean,
    dataStore?: StatisticDataStore,
    forceBusyIndicator?: boolean,
    uiValues: any,
    ui: any,
    hideParameters?: boolean,
    context?: any
};
export class StatisticViewer extends React.Component<IStatisticViewerProps, StatisticViewerState> {
    private statisticWidgetId: string;
    private rootNode: HTMLDivElement;
    private layoutNode: HTMLDivElement;
    private lastParamsStr: string;
    constructor(props: IStatisticViewerProps) {
        super(props);
        this.statisticWidgetId = kendo.guid();

        let newState: StatisticViewerState = ({ ui: this.props.uiDefinition, uiValues: this.props.parameters || {} });
        newState.dataStore = props.dataStore ? props.dataStore : new StatisticDataStore(this.handleBeginDataLoad, this.handleFinishedDataLoad);
        if (props.dataStore) {
            props.dataStore.onBeginDataLoad = this.handleBeginDataLoad;
            props.dataStore.onFinishedDataLoad = this.handleFinishedDataLoad;
        }

        var context: utility.IContextProps = {
            loadMissingData: this.loadMissingData,
            registerComponent: this.registerComponent,
            reloadAllData: this.reloadAllData,
            reloadCurrentData: this.reloadAllDataFromCurrentParams,
            variables: this.props.contextVariables,
            unregisterComponent: this.unregisterComponent,
            loadChildData: this.loadChildData,
            drillDownObject: this.props.drillDowny,
            fullHeightLayout: this.props.uiDefinition.settings?.fullHeight
        };
        newState.context = context;
        const paramsFromStorage = Helper.loadDataFromStorage(this.getLocalstorageName());
        if (this.props.controllerCode) {
            try {
                let controllerResult = this.internalControllerEval(this.props.controllerCode);
                if (controllerResult && controllerResult.getInitialValues) {
                    try {
                        newState.uiValues = controllerResult.getInitialValues(paramsFromStorage, $.isEmptyObject(this.props.parameters) ? null : this.props.parameters, this.props.drillDownParams) || {};
                    } catch (e) {
                        console.error("Error in controller: " + e);
                    }
                }
            } catch (e) {
                console.error("Could not execute script. " + e.toString());
            }
        } else {
            const parametersCopy = { ...this.props.parameters };
            delete parametersCopy["isEmbedded"];
            delete parametersCopy["refreshIfParametersChanged"];

            if ($.isEmptyObject(parametersCopy) && (!this.props.uiDefinition || !this.props.uiDefinition.settings || this.props.uiDefinition.settings?.disableLoadParamsFromStorage != true) && !this.props.isDrillDown) {
                newState.uiValues = paramsFromStorage || {};
            }
        }

        if (this.props.uiDefinition.settings && this.props.uiDefinition.settings?.startWithCollapsedParameters) {
            newState.hideParameters = true;
        }
        this.state = newState;
    }

    private internalControllerEval = (codeToEval: string): any => {
        return eval(codeToEval);
    }

    getLocalstorageName = () => {
        return "inputParameter" + (this.props.uiDefinition.settings && this.props.uiDefinition.settings?.saveParametersForStatistic ? this.props.realStatisticId : "");
    }

    handleBeginDataLoad = () => {
        this.setState({ isLoading: true });
    }

    handleFinishedDataLoad = () => {
        this.setState({ isLoading: false, forceBusyIndicator: false });
    }

    UNSAFE_componentWillReceiveProps(nextProps: IStatisticViewerProps) {
        this.setState({ ui: nextProps.uiDefinition });

    }

    private getStatisticParameters = (): any => {
        const parameters = this.props.refreshIfParametersChanged ? { ...this.state.uiValues, ...this.props.parameters } : { ...this.state.uiValues };
        return parameters;
    }

    componentDidUpdate(prevProps, prevState) {
        const isVisible = this.isElementVible(this.rootNode);
        if (this.props.refreshIfParametersChanged && isVisible && (this.lastParamsStr != JSON.stringify(this.props.parameters))) {
            this.lastParamsStr = JSON.stringify(this.props.parameters);
            this.reloadAllDataFromCurrentParams();
        }

        if (this.state.isLoading != prevState.isLoading) {
            kendo.ui.progress($(this.layoutNode), this.state.isLoading);
        }
    }

    isElementVible = (elem) => {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    }

    handleValueChange = (name, value) => {
        let uiValues = this.state.uiValues;
        uiValues[name] = value;

        this.setState({ uiValues: uiValues }, () => {
            if (this.props.uiDefinition.settings?.reloadOnChange) {
                this.handleReloadClicked();
            }
        });
    }

    registerComponent = (componentId: string, requiredServices: string[], callback: any, additionalParams: any, datastore: any) => {
        this.state.dataStore.registerService(componentId, requiredServices, callback, additionalParams, datastore);
    }

    unregisterComponent = (componentId) => {
        this.state.dataStore.unregisterServices(componentId);
    }

    loadMissingData = (params, additionalParams) => {
        this.state.dataStore.loadMissingData(this.state.uiValues);
    }

    loadChildData = (params, additionalParams) => {
        this.state.dataStore.loadChildData(this.state.uiValues, additionalParams);
    }

    reloadAllDataFromCurrentParams = (parametersToSave?: ParamsToStore) => {
        this.reloadAllData(this.getStatisticParameters(), parametersToSave);
    }

    reloadAllData = (parameters, parametersToSave?: ParamsToStore) => {
        this.state.dataStore.reloadAllData(parameters, parametersToSave);
    }

    componentDidMount() {
        const settings = this.state.ui.settings;
        if (this.state.ui && (((this.state.ui.parameters && this.state.ui.parameters.length == 0)) || (settings && settings.loadDataOnStart == true) || this.props.isDrillDown == true)) {
            this.loadMissingData(null, null);
        }

        if (settings && settings.autorefreshInterval) {
            const interval = Number(settings.autorefreshInterval);
            if (interval) {
                setInterval(() => {
                    this.reloadAllDataFromCurrentParams();
                }, Math.max(5000, interval * 1000))
            }
        }
        window["DelphiInterop"] = window["DelphiInterop"] || {};

        window["DelphiInterop"].refreshStatisticStack = window["DelphiInterop"].refreshStatisticStack || [];
        window["DelphiInterop"].statisticWidgets = window["DelphiInterop"].statisticWidgets || {};
        window["DelphiInterop"].statisticWidgets[this.statisticWidgetId] = {
            api: {
                reload: () => { this.setState({ forceBusyIndicator: true }); this.reloadAllDataFromCurrentParams(); }
            }
        };

        window["DelphiInterop"].refreshStatisticStack.push(() => {
            this.reloadAllDataFromCurrentParams();;
        });
    }

    componentWillUnmount() {
        window["DelphiInterop"].refreshStatisticStack.pop();
        delete window["DelphiInterop"].statisticWidgets[this.statisticWidgetId];
        this.state.dataStore.cancelRequests();
    }

    handleReloadClicked = () => {
        const statisticStorageKey = this.getLocalstorageName();
        const valuesToStore = JSON.stringify(this.state.uiValues);
        this.reloadAllDataFromCurrentParams({ StorageKey: statisticStorageKey, ParamsToStore: valuesToStore });
    }

    handleHideShowParams = (hide: boolean) => {
        this.setState({ hideParameters: hide });
    }

    renderParametersClosed = () => {

        return (
            <div style={{ flex: "0 0 45px" }}>
                <button className="btn btn-success btn-sm prev_btn" style={{ marginLeft: "5px" }} onClick={this.handleHideShowParams.bind(this, false)}>+</button>
            </div>)
    }

    renderParametersOpen = () => {

        let params = this.state.ui && this.state.ui.parameters && this.state.ui.parameters.length > 0
            ? <div style={{ flex: "0 0 300px" }}>
                <ParameterViewer
                    uiComponents={this.state.ui.parameters}
                    parameters={this.state.uiValues}
                    onValueChange={this.handleValueChange}
                    onHidenParams={this.handleHideShowParams.bind(this, true)}
                    contextVariables={this.props.contextVariables}
                    hideReloadButton={this.props.uiDefinition.settings?.reloadOnChange}
                    onReloadDataClicked={this.handleReloadClicked} />
            </div>
            : null

        return params;
    }

    renderParameters = () => {

        if (!this.state.hideParameters) {
            return this.renderParametersOpen();
        }
        else {
            return this.renderParametersClosed();
        }
    }

    renderLayout = () => {
        const newContextVariables = this.props.contextVariables || {};
        newContextVariables.STATISTIC_WIDGET_ID = this.statisticWidgetId;

        return (
            <>
                <div ref={(e) => { this.layoutNode = e }} style={{ display: "flex", flex: "1", height: "100%" }}>
                    <div style={{ overflow: !this.props.isEmbedded ? "auto" : "unset", flex: "1", height: "100%" }}>
                        <react_components.ReactDynamicUi uiId={this.props.statisticId}
                            uiDefinition={this.state.ui}
                            onTextChange={this.handleValueChange}
                            parameters={this.state.uiValues}
                            contextVariables={newContextVariables}
                            queryParameter={this.state.uiValues}
                            context={this.state.context} />
                    </div>
                    {this.renderParameters()}
                </div>
            </>
        )
    }

    renderEmbeddedLayout = () => {
        return <StatisticUiEmbeddedLayout
            context={this.state.context}
            contextVariables={this.props.contextVariables}
            forceBusyIndicator={this.state.forceBusyIndicator}
            handleReloadClicked={this.handleReloadClicked}
            handleValueChange={this.handleValueChange}
            isLoading={this.state.isLoading}
            parameters={this.props.parameters}
            statisticId={this.props.statisticId}
            statisticWidgetId={this.statisticWidgetId}
            ui={this.state.ui}
            uiValues={this.state.uiValues}
        />
    }

    render() {
        return <div ref={(e) => this.rootNode = e} style={{ height: "100%" }}>{this.props.isEmbedded ? this.renderEmbeddedLayout() : this.renderLayout()}</div>;
    }
};

class StatisticUiEmbeddedLayout extends React.Component<{ ui, handleValueChange, uiValues, contextVariables, statisticWidgetId, handleReloadClicked, statisticId, isLoading, forceBusyIndicator, context, parameters }, { showParameterDialog: boolean }> {
    private rootNode: HTMLDivElement;

    constructor(props) {
        super(props)
        this.state = {
            showParameterDialog: false
        };
    }

    hasParameters = () => {
        return this.props.ui.parameters && this.props.ui.parameters.length > 0;
    }

    renderEmbeddedParameters = () => {
        return this.hasParameters() ? <div style={{
            zIndex: 1000,
            position: "absolute",
            right: "0px"
        }}>
            <Button buttonStyle={{ width: "30px" }}
                iconName="cog"
                handleClick={(e) => { e.preventDefault(); this.setState({ showParameterDialog: true }) }}></Button> </div>
            : null;
    }

    componentDidUpdate(prevprops) {
        if (this.props.isLoading != prevprops.isLoading) {
            kendo.ui.progress($(this.rootNode), this.props.isLoading);
        }
    }
    private kendoDialog: kendo.ui.Dialog;

    handleOpenSheet = (componentSearchProps, handleFieldClicked, handleObjectChanged, onOpened) => {
        this.kendoDialog.setOptions({
            visible: false
        });
        new SearchHelper().openSearch(componentSearchProps, (p1, p2, p3) => {
            this.kendoDialog.setOptions({ visible: true }); handleFieldClicked(p1, p2, p3)
        }, handleObjectChanged, onOpened, () => { this.kendoDialog.setOptions({ visible: true }) });
    }

    render() {
        const newContextVariables = this.props.contextVariables || {};
        newContextVariables.STATISTIC_WIDGET_ID = this.props.statisticWidgetId;

        const paramsDialog = this.state.showParameterDialog ? <ParametersDialog
            dialogInternalRef={(dialogRef) => { this.kendoDialog = dialogRef }}
            onClose={() => this.setState({ showParameterDialog: false })}
            onSave={() => {
                this.props.handleReloadClicked();
                this.setState({ showParameterDialog: false });
            }} >
            <ParameterViewerComponentList
                uiComponents={this.props.ui.parameters}
                parameters={this.props.uiValues}
                contextVariables={this.props.contextVariables}
                onValueChange={this.props.handleValueChange}
                openSheet={this.handleOpenSheet}></ParameterViewerComponentList>
        </ParametersDialog> : null;
        return (
            <>
                {paramsDialog}
                <div ref={(e) => this.rootNode = e}
                    style={{
                        display: "flex",
                        flex: "1",
                        height: "100%",
                        flexDirection: "column",
                        position: "relative",
                        minHeight: "50px"
                    }}>
                    {this.renderEmbeddedParameters()}
                    <div style={{ overflow: "visible", flex: "1", height: "100%", marginRight: "15px", marginTop: this.hasParameters() ? "15px" : "0px" }}>
                        <react_components.ReactDynamicUi uiId={this.props.statisticId}
                            uiDefinition={this.props.ui}
                            onTextChange={this.props.handleValueChange}
                            parameters={this.props.uiValues}
                            contextVariables={newContextVariables}
                            queryParameter={this.props.uiValues}
                            context={this.props.context} />
                    </div>
                </div>
            </>
        )
    }
}

interface IParameterView {
    uiComponents: any;
    parameters: any;
    onValueChange(property, value);
    contextVariables: any;
    onHidenParams: any;
    onReloadDataClicked: any;
    hideReloadButton?: boolean;
}

interface ParameteersDialogProps extends React.PropsWithChildren { onClose: any, onSave: any, dialogInternalRef?: (dialog: kendo.ui.Dialog) => void; }
class ParametersDialog extends React.Component<ParameteersDialogProps, any> {
    render() {
        return <react_components.BasicDialog
            height="60%"
            width="450px"
            onClose={this.props.onClose}
            title="Parameter"
            okayLabel="OK"
            dialogInternalRef={this.props.dialogInternalRef}
            onSave={this.props.onSave} >
            {this.props.children}
        </react_components.BasicDialog >
    }
}
class ParameterViewer extends React.Component<IParameterView, any> {
    handleTextChange = (property, value) => {
        this.props.onValueChange(property, value);
    }

    hasValue = (values): boolean => {
        if (Array.isArray(values)) {
            return values.length > 0;
        }
        return Helper.hasValue(values) && values !== "";
    }

    hasEmptyMandatoryFields = (uiComponents): boolean => {

        for (var comp of uiComponents) {
            const metadata: any = utility.getMetaDataForComponent(comp);

            if (metadata.isMandatory && !this.hasValue(this.props.parameters[metadata.name])) {
                return true;
            }
        }

        return false;
    }

    getHeader = () => {
        return (<div style={{ color: "#fff", background: "#3c8dbc", backgroundColor: "#777", display: "flex", alignItems: "center" }}>
            <h3 style={{ padding: "10px 0px 10px 10px", margin: "0px", display: "inline-block", color: "white", fontSize: "16px", fontWeight: 400 }}>Parameter</h3>
            <button style={{ marginLeft: "auto", marginRight: "5px" }} onClick={this.props.onHidenParams} className="btn btn-success btn-sm prev_btn">-</button>
        </div>)
    }

    render() {
        if (!this.props.uiComponents) {
            return null;
        }
        const okayButton = !this.props.hideReloadButton && !this.hasEmptyMandatoryFields(this.props.uiComponents) ? <div className="innoKMenuStrip" style={{ width: "100px" }}>
            <react_components.InnoButtonOkay label="OK" onClick={this.props.onReloadDataClicked} />
        </div> : null

        return (
            <div style={{ marginLeft: "5px", backgroundColor: "white" }}>
                {this.getHeader()}
                <div className="box-body">
                    <ParameterViewerComponentList uiComponents={this.props.uiComponents} parameters={this.props.parameters} contextVariables={this.props.contextVariables} onValueChange={this.handleTextChange} ></ParameterViewerComponentList>
                    {okayButton}
                </div>
            </div>
        );
    }
};

interface IParameterViewComponentList {
    uiComponents: any;
    parameters: any;
    onValueChange(property, value);
    contextVariables: any;
    openSheet?: any;
}

export class ParameterViewerComponentList extends React.Component<IParameterViewComponentList, any> {
    handleTextChange = (property, value) => {
        this.props.onValueChange(property, value);
    }

    hasValue = (values): boolean => {
        if (Array.isArray(values)) {
            return values.length > 0;
        }
        return Helper.hasValue(values) && values !== "";
    }

    renderInputControl = (component, values) => {
        var context: utility.IContextProps = {
            loadMissingData: null,
            registerComponent: null,
            reloadAllData: null,
            reloadCurrentData: null,
            variables: this.props.contextVariables,
            unregisterComponent: null,
            loadChildData: null,
            openSheet: this.props.openSheet
        };
        const metadata: any = utility.getMetaDataForComponent(component);
        const errors = metadata.hasErrors() ? <pre style={{ color: "red" }}>Some mandatory fields are missing</pre> : null;
        const style: React.CSSProperties = { marginBottom: "10px" };
        if (metadata.isMandatory && !this.hasValue(values[metadata.name])) {
            style.border = "2px solid red";
        }
        var compObj = <div key={component.uid} style={style}> {errors}{utility.getComponentBySettings(component, values, this, null, context, null, "")}</div>;

        if (compObj) {
            return compObj;
        }
    }

    render() {
        let comps = this.props.uiComponents.map((c) => {
            return this.renderInputControl(c, this.props.parameters);
        });
        return comps;
    }
}

export class DrillDownStatisticViewer extends React.Component<any, any> {
    private isLoading: boolean;
    private statisticController = new StatisticUiController();
    private drillDowny: any;
    constructor(props) {
        super(props);

        let copyOfUrlParams = utility.getQueryParamsFromSearch();
        if (props.location && props.location.query) {
            copyOfUrlParams = $.extend({}, props.params, props.location.query);
        }

        this.removePropertiesIgnoreCase(copyOfUrlParams, ["nowest", "nonorth", "noeast", "kioskmode", "_hideMenu"]);
        this.drillDowny = utility.getDrillDownObject();
        this.drillDowny.onDrillDown = this.onDrillDown;
        this.getUi(props.match.params.statisticId, copyOfUrlParams, true, null, false);
        this.state = { ui: props.ui, uiValues: {}, crumbs: [], hideParameters: false };
    }

    removePropertiesIgnoreCase = (obj: {}, propertiesToRemove: string[]) => {
        if (!obj || !propertiesToRemove) {
            return;
        }

        for (let p in obj) {
            if (propertiesToRemove.filter((val) => (val.toLowerCase() == p.toLowerCase())).length > 0) {
                delete obj[p];
            }
        }
    }

    getQueryParams = (props) => {
        let queryParams = utility.getQueryParamsFromSearch();
        if (queryParams) {
            delete queryParams["statisticId"];
        }
        if (props.location && props.location.query) {
            queryParams = $.extend({}, props.params, props.location.query);
        }
        return queryParams;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const queryParams = this.getQueryParams(nextProps);
        const noDrillDown = queryParams['_drilldown'] ? false : true;

        if (nextProps.match.params.statisticId !== this.props.match.params.statisticId) {
            this.getUi(nextProps.match.params.statisticId, queryParams, noDrillDown, null, !noDrillDown)
        } else if (nextProps.location.query.__GUID !== this.props.location.query.__GUID) {
        }
    }

    componentWillUnmount() {
        this.statisticController.cancel();
    }

    handleCrumbClick = (index) => {
        var statisticsUi = this.state.statisticsUi;
        statisticsUi.splice(index + 1, statisticsUi.length - index + 1);
        var crumbs = this.state.crumbs;
        crumbs.splice(index + 1, crumbs.length - index + 1);

        this.setState({ crumbs: crumbs, statisticsUi: statisticsUi }, () => {
            window["redrawKendoOnResize"] && window["redrawKendoOnResize"]();
        });
    }

    createStatisticViewer = (statisticId, queryParams, initialLoad, drillDownParams, data, isDrillDown: boolean, realStatisticId: number) => {
        const hideMenu = queryParams["_hideMenu"] === "true" || queryParams["kioskmode"] === "1";
        return (
            <StatisticViewer
                isEmbedded={queryParams.isEmbedded}
                refreshIfParametersChanged={queryParams.refreshIfParametersChanged}
                key={statisticId}
                statisticId={statisticId}
                uiDefinition={data.Config}
                parameters={queryParams}
                controllerCode={data.StatisticController}
                contextVariables={data.ContextVariables}
                hideParameters={this.state.hideParameters}
                menuHidden={hideMenu}
                drillDownParams={drillDownParams}
                isDrillDown={isDrillDown}
                drillDowny={this.drillDowny}
                realStatisticId={realStatisticId}
            >
            </StatisticViewer>)
    }

    getUi = (statisticId, queryParams, initialLoad, drillDownParams, isDrillDown: boolean) => {
        //HACK: ein Fix für den Fall, dass die Methoden componentWillReceiveProps und getInitialState gleichzeitig feuern;
        if (this.isLoading !== true) {
            this.isLoading = true;
            this.statisticController.GetStatisticTranslated(statisticId, queryParams.isEmbedded || false, (result) => {
                if (Helper.hasValue(result.StoredParams?.StorageValue)) {
                    Helper.saveDataToStorage(result.StoredParams.StorageKey, result.StoredParams.StorageValue, true);
                }
                if (!result.Config) {
                    this.isLoading = false;
                    return;
                }
                var crumbs = this.state.crumbs;
                var statisticsUi = this.state.statisticsUi;

                if (initialLoad === true) {
                    statisticsUi = [];
                    crumbs = [];
                }

                const statisticParameter = {
                    statisticId: statisticId, queryParams: queryParams, initialLoad: initialLoad, drillDownParams: drillDownParams, result: result, isDrillDown: isDrillDown
                };

                statisticsUi.push(statisticParameter);
                crumbs.push({ name: result.Name, description: result.Description, settings: result, });
                this.setState({ ui: result, uiValues: queryParams, crumbs: crumbs, statisticsUi: statisticsUi });
                this.isLoading = false;
            }, () => { this.isLoading = false; });
        }
    }

    onDrillDown = (values, statisticId, drillDownParams) => {
        this.getUi(statisticId, values, false, drillDownParams, true);
    }

    renderBreadCrumbs = () => {
        if (this.props.hideBreadCrumb && this.state.crumbs && this.state.crumbs.length > 1) {
            return <a style={{ color: "#428bca", textDecoration: "none" }} onClick={() => this.handleCrumbClick(0)}>{Helper.getTranslation("Standard.BackBtn")}</a>
        }
        else if (this.props.hideBreadCrumb) {
            return null;
        }

        return <BreadCrumb crumbs={this.state.crumbs} onCrumbClick={this.handleCrumbClick} parameters={this.state.uiValues} />;
    }

    render() {
        const queryParams = this.getQueryParams(this.props);
        if (Array.isArray(this.state.statisticsUi)) {
            var dialogs = this.state.statisticsUi.map((statisticParameter, index) => {
                index++;
                if (index == this.state.statisticsUi.length) {

                    return <div key={index} style={{ height: "100%" }}>{this.createStatisticViewer(statisticParameter.statisticId + index, statisticParameter.isDrillDown ? statisticParameter.queryParams : queryParams, statisticParameter.initialLoad, statisticParameter.drillDownParams, statisticParameter.result, statisticParameter.isDrillDown, statisticParameter.statisticId)}</div>;
                }
                else {
                    return <div key={index} style={{ display: 'none' }}>{this.createStatisticViewer(statisticParameter.statisticId + index, statisticParameter.queryParams, statisticParameter.initialLoad, statisticParameter.drillDownParams, statisticParameter.result, statisticParameter.isDrillDown, statisticParameter.statisticId)}</div>;
                }
            });
        }


        return (
            <FullHeightContainer style={{ marginLeft: "10px", marginRight: "10px" }}>
                {this.renderBreadCrumbs()}
                {dialogs}
            </FullHeightContainer>
        )
    }
};

interface IBreadCrumb {
    crumbs: any;
    onCrumbClick: any;
    parameters?: any;
}

class BreadCrumb extends React.Component<IBreadCrumb, any> {

    constructor(props) {
        super(props);

        this.state = {}
    }

    handleClick = (index) => {
        this.props.onCrumbClick(index);
    }

    getDescriptionFromTemplate = (template: any) => {
        if (!template) {
            return { __html: "" };
        }
        try {
            template = kendo.template(template);
            var result: any = template({});
        }
        catch (e) {
            result = '<div style = "color:red">Error in template:' + e.message + '</div>';
        }
        return { __html: result };
    }

    handleShowDescriptionClicked = (crumb) => {
        var showDescription = this.state.showDesription || false;
        this.setState({ showDesription: !showDescription });
    }

    extractServiceId = (dataUrl): string => {
        var index = dataUrl.substring(15, dataUrl.length);
        index = index.substring(0, index.indexOf('/'));
        return index;
    }

    generateUrl = (esportSettings): string => {
        var url = "api/DynamicApi/" + this.extractServiceId(esportSettings.dataUrl) + "/GetExportFile?"
        var newParams = $.extend({ __templateName: esportSettings.excelTemplateName }, this.props.parameters);
        url += $.param(newParams);
        return url;
    }

    generateExportButton = () => {

        let settings = this.props.crumbs && this.props.crumbs.length > 0 ? this.props.crumbs[this.props.crumbs.length - 1].settings : null;
        settings = settings && settings.Config ? settings.Config.settings : null;
        if (!settings || !settings.exports || settings.exports.length === 0) {
            return null;
        }

        const links = settings.exports.map((e) => { return <li><a href={this.generateUrl(e)}>{e.label}</a></li> });
        return (
            <div className="btn-group pull-right">
                <button type="button" className="btn btn-success dropdown-toggle no-print" data-toggle="dropdown">
                    Export <span className="caret"></span>
                </button>
                <ul className="dropdown-menu" role="menu">
                    {links}
                </ul>
            </div>);
    }

    render() {
        let crumbs;
        let that = this;
        let description;

        if (this.state.showDesription && this.props.crumbs) {
            let temlate = this.props.crumbs[that.props.crumbs.length - 1].description;
            if (temlate) {
                description = <div style={{ height: "500px", overflowY: "auto" }} dangerouslySetInnerHTML={this.getDescriptionFromTemplate(temlate)}></div>
            }
        }
        if (Array.isArray(this.props.crumbs)) {
            crumbs = this.props.crumbs.map(function (crumb, index) {

                let badge = null;

                if (crumb.description) {
                    badge = <span>?</span>;
                }

                if (index != that.props.crumbs.length - 1) {
                    return <li key={index} style={{ color: "#428bca" }} >
                        <a style={{ color: "#428bca", textDecoration: "none" }} onClick={() => that.handleClick(index)}>{crumb.name}</a>
                        /
                    </li>;
                }
                return <li key={index} style={{ color: "#000" }} className="active"><a style={{ color: "#428bca", textDecoration: "none" }} onClick={() => that.handleShowDescriptionClicked(crumb)}>{crumb.name} {badge}</a></li>;
            });
        }
        return (
            <>
                <ul style={{
                    fontSize: "18px",
                    padding: "8px 15px",
                    marginBottom: "20px",
                    listStyle: "none",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                    height: "40px",
                    flexShrink: 0,
                    display: "flex",
                    marginTop: "10px"
                }}>
                    {crumbs}
                    {this.generateExportButton()}
                </ul>
                {description}
            </>)
    }
};

interface renderDrillDownConfig {
    basePath: string;
    elementId?: string;
    element?: HTMLElement;
    statisticId?: string;
    selectedElement?: any;
    params?: {};
    handleValueChanged?: any;
    handleSettingsChanged?: any;
}

export var renderDrillDownStatistic = (config: renderDrillDownConfig) => {
    const s = getGlobalSettings();
    let settings = s.GetSettings();
    if (!settings) {
        settings = { INNO_BASE_PATH: config.basePath };
        s.SetSettings(settings);
    }
    return (
        <DrillDownStatisticViewer
            hideBreadCrumb={true}
            match={{ params: { statisticId: config.statisticId } }}
            params={{ refreshIfParametersChanged: true, isEmbedded: true }}
            location={{ query: config.params || {} }}>
        </DrillDownStatisticViewer >
    );
}

export var renderPropertyEditor = (config: renderDrillDownConfig) => {
    const s = getGlobalSettings();
    let settings = s.GetSettings();
    if (!settings) {
        settings = { INNO_BASE_PATH: config.basePath };
        s.SetSettings(settings);
    }
    const metaDataClass = utility.getEditorMetadata("is-get-next-number");
    const instance = propertyTypes.InstanceLoader.getInstance(metaDataClass, null, null);
    const metadata = instance.getMetadata();

    return <common_components.PropertiesEditor properties={metadata} selectedElement={config.selectedElement} onSettingsChanged={config.handleSettingsChanged} contextVariables={settings}></common_components.PropertiesEditor>
}

export var renderWebSmsUiEditor = (channel: string, basepath: string, metadataType: string) => {
    const s = getGlobalSettings();
    let settings = s.GetSettings();
    if (!settings) {
        settings = { INNO_BASE_PATH: basepath };
        s.SetSettings(settings);
    }

    ReactDOM.render(<WebSmsUiEditor channel={channel} settings={settings} metadataType={metadataType} />, document.getElementById("app"));
}
